<template>
  <react-component v-bind="$props" />
</template>

<script>
import MyReactComponent from "./FollowButton";

export default {
  components: { "react-component": MyReactComponent },
  props: ["channel", "isFollowing", "outline"],
};
</script>